import { SupplierFeature } from '../constants/featurePermissionMap'
import {
  isFeatureActive,
  useSupplierFeatures,
} from '../data/useSupplierFeatures'
import { Unauthorized } from './Unauthorized'

/**
 * A guard component that controls access to protected content
 * based on whether a supplier feature is active.
 *
 * Use this inside routes alongside ProjectGuard to prevent
 * access to features that are deactivated for the current supplier.
 *
 * @example
 * ```tsx
 * <ProjectGuard permissionName={Permissions.Project.Worklist}>
 *   <FeatureGuard feature="orderProcess">
 *     <OrdersPage />
 *   </FeatureGuard>
 * </ProjectGuard>
 * ```
 */
type FeatureGuardProps = {
  feature: SupplierFeature
  children?: React.ReactNode
}

export const FeatureGuard: React.FC<FeatureGuardProps> = ({
  feature,
  children,
}) => {
  const features = useSupplierFeatures()

  if (features.isLoading) return null

  if (!isFeatureActive(features, feature)) return <Unauthorized />

  return <>{children}</>
}
